// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { skipArrow16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-skip-arrow': IconSkipArrow;
    }
}

/**
 * The icon component for the 'skipArrow' icon
 */
export class IconSkipArrow extends IconSvg {
    public constructor() {
        super(skipArrow16X16);
    }
}

registerIconSvg('icon-skip-arrow', IconSkipArrow);
export const iconSkipArrowTag = 'nimble-icon-skip-arrow';
